<div class="form-search">
  <div>
    <button matButton aria-label="add" (click)="filters()">
      Filtros
    </button>
  </div>
  <div>
    <mat-chip-set aria-label="filtros">
      @if (criteriaData?.insurerId) {
        <mat-chip class="custom-mat-chip"
                  [disableRipple]="true">{{ criteriaData?.insurerId?.description }}
        </mat-chip>
      } @for (criteria of criteriaData?.status; track criteria) {
      <mat-chip class="custom-mat-chip" [disableRipple]="true">{{ criteria[1] }}</mat-chip>
    } @if (criteriaData?.insurableInterestIdentifier) {
      <mat-chip class="custom-mat-chip" [disableRipple]="true">
        Placa: {{ criteriaData.insurableInterestIdentifier }}
      </mat-chip>
    } @if (criteriaData?.insuredId) {
      <mat-chip class="custom-mat-chip" [disableRipple]="true">
        Asegurado: {{ criteriaData.insuredId }}
      </mat-chip>
    }
    </mat-chip-set>
  </div>
</div>
